import React from 'react';
import { SvgIcon } from 'ui/SvgIcon';
import CheckIcon from 'ui/Icons/tabler/check.component.svg';
import { IFilterChipProps } from './types';

export const FilterChip: React.FC<IFilterChipProps> = ({ label, isSelected, onClick }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`
        flex items-center justify-center gap-[5px] px-[10px] h-[30px]
        rounded-[10px] border  text-[15px] cursor-pointer
        ${
          isSelected
            ? 'bg-green-25 border-green-prime text-green-hard font-bold leading-[1.2]'
            : 'bg-white border-brown-prime text-brown-prime leading-[1.272] hover:bg-brown-20'
        }
      `}
    >
      {isSelected && (
        <SvgIcon IconComponent={CheckIcon} className="w-[14px] h-[14px] fill-transparent stroke-green-hard stroke-2" />
      )}
      <span className="font-pt-sans">{label}</span>
    </button>
  );
};
